/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { func, string } from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles((theme) => ({
    headerWrapper: {
        margin: '10px 0px',
        display: 'flex',
        padding: '0px 1rem',
    },
    productTitle: {
        textTransform: 'uppercase',
        fontSize: '1.5rem',
        textAlign: 'center',
        fontFamily: theme.typography.secondaryFontFamily,
        fontWeight: '400',
        margin: 0,
        maxWidth: '80%',
        lineHeight: '28px',
    },
    backButton: {
        border: 'none',
        background: 'none',
        flex: '0.5',
        textAlign: 'left',
        cursor: 'pointer',
    },
}));

const MobileHeader = ({ goBackButton, productName }) => {
    const classes = useStyles();
    return (
        <div className={classes.headerWrapper}>
            <button
                type="button"
                className={classes.backButton}
                onClick={goBackButton}
            >
                <ArrowBackIcon />
            </button>
            <h3 className={classes.productTitle}>
                {productName}
            </h3>
        </div>
    );
};

MobileHeader.propTypes = {
    goBackButton: func.isRequired,
    productName: string.isRequired,
};

export default MobileHeader;
